'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}><path fill="currentColor" fillRule="evenodd" d="M3 3.964c0-1.517 1.67-2.46 2.994-1.69L19.02 9.837a1.948 1.948 0 0 1 .09 3.326L6.083 21.67C4.763 22.534 3 21.6 3 20.036zm15.013 7.563L4.987 3.964v16.072z" clipRule="evenodd" /></svg>;
const IconPlay = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconPlay;